import React from 'react'
import AutoForm from '@components/AutoForm'
import {Field} from 'simple-react-form'
import Text from '@packages/justo-parts/lib/components/fields/Text'
import Button from '@components/Button'
import ObjectField from '@components/fields/ObjectField'
import useRef from '@hooks/useRef'
import SignTerms from '@components/SignTerms'
import useState from '@hooks/useState'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'
import useWebsiteInfo from '@hooks/useWebsiteInfo'
import Phone from '@components/fields/Phone'
import {useTranslation} from 'next-i18next'

export default function Register(props) {
  const {t} = useTranslation('auth')
  const {onSuccess, email, changeEmail} = props
  const button = useRef()
  const {websiteId, websiteName, websiteCountryCode: countryCode} = useWebsiteInfo()
  const [termSignatures, setTermSignatures] = useState([])
  const {pendingTermInfos} = useQuery({
    query: gql`
      query pending($email: String, $websiteId: String) {
        pendingTermInfos(email: $email, websiteId: $websiteId)
      }
    `,
    variables: {email, websiteId}
  })
  const [doc, setDoc] = useState<{
    email: string
    profile: any
    termSignatures: any
    websiteId: string
    phone?: string
  }>({
    email,
    profile: {},
    termSignatures,
    websiteId
  })

  const missingFields = !doc.profile || !doc.profile.firstName || !doc.profile.lastName

  const requiredTermInfos = (pendingTermInfos || []).filter(term => !term.optional)
  const requiredTermVersions = requiredTermInfos.map(term => term.latestVersion)

  const signedVersions = termSignatures.map(term => term.version)
  const missingSignatures = requiredTermVersions.some(version => !signedVersions.includes(version))

  return (
    <AutoForm
      doc={{
        ...doc,
        termSignatures: missingSignatures ? {} : termSignatures
      }}
      mutation="registerAndSignTerms"
      buttonRef={button}
      onSuccess={onSuccess}
      onChange={({profile, phone}) => {
        setDoc({
          ...doc,
          phone,
          profile
        })
      }}>
      <div className="label">Email</div>
      <Field fieldName="email" type={Text} fieldType="email" placeholder="Email" disabled />
      {changeEmail ? (
        <>
          <div className="description">
            ¿Quieres usar otro email? <a onClick={() => changeEmail()}>Cambiar email</a>
          </div>
        </>
      ) : null}
      <Field fieldName="profile" type={ObjectField} style={null}>
        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="label">{t('name')}</div>
            <Field fieldName="firstName" type={Text} placeholder={t('name')} />
          </div>
          <div className="col-xs-12 col-sm-6">
            <div className="label">{t('lastName')}</div>
            <Field fieldName="lastName" type={Text} placeholder={t('lastName')} />
          </div>
        </div>
      </Field>
      {countryCode ? (
        <div>
          <div className="label">Número de teléfono</div>
          <Field fieldName="phone" type={Phone} />
        </div>
      ) : null}
      <br />
      <SignTerms
        websiteId={websiteId}
        websiteName={websiteName}
        termInfos={pendingTermInfos}
        termSignatures={termSignatures}
        setTermSignatures={setTermSignatures}
      />
      <Button primary ref={button} disabled={missingFields || missingSignatures}>
        Continuar
      </Button>
    </AutoForm>
  )
}
